import { render, staticRenderFns } from "./editFeeConfig.vue?vue&type=template&id=7bcdef03&scoped=true"
import script from "./editFeeConfig.vue?vue&type=script&lang=js"
export * from "./editFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./editFeeConfig.vue?vue&type=style&index=0&id=7bcdef03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcdef03",
  null
  
)

export default component.exports